















import { ciExternalLink } from '~/icons/source/regular/external-link'
import { computed, defineComponent, PropType } from '~/utils/nuxt3-migration'

interface ExternalLink {
  domain: string
  type: string
  url: string
}

export default defineComponent({
  props: {
    externalLink: {
      type: Object as PropType<ExternalLink>,
      required: true
    },
    linkClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup(props) {
    const isRental = computed(() => props.externalLink.type === 'rental')
    return { ciExternalLink, isRental }
  }
})
